import React from 'react';
import { Tooltip, Box, Type, Tiles } from '@nerdwallet/currency';
// eslint-disable-next-line lodash/import-scope
import { filter, cloneDeep } from 'lodash';

import CityInputSelect from '../../shared/inputs/city-input-select/city-input-select';
import HouseholdIncomeInput from '../../shared/inputs/household-income-input/household-income-input';

type ColResultsHeaderProps = {
  cities: Record<string, string>[];
  sourceCity: string;
  destinationCity: string;
  onChange: (value: any, key: any) => void;
};

function getCityOptions(cities = []) {
  const sortedCities = cities.sort((a, b) => {
    const stateCompare = a.state.localeCompare(b.state);

    if (stateCompare !== 0) {
      return stateCompare;
    }

    return a.name.localeCompare(b.name);
  });

  const options = sortedCities.map((city) => ({
    label: `${city.name}, ${city.state_abbr}`,
    value: city.id,
    clearableValue: false,
    state: city.state,
  }));

  const groupedOptions = cloneDeep(options);
  let currentState = '';
  let offset = 0;

  options.forEach((option, index) => {
    if (option.state !== currentState) {
      currentState = option.state;

      // insert state header at this index because state changed
      // use offset to account for change in list size
      groupedOptions.splice(index + offset, 0, {
        label: `${currentState}`,
        value: null,
        // @ts-ignore - ignore error
        disabled: true,
        isState: true,
      });

      offset += 1;
    }
  });

  return groupedOptions;
}

const ColResultsHeader = ({
  cities,
  sourceCity,
  destinationCity,
  onChange,
}: ColResultsHeaderProps): JSX.Element => {
  const cityItems = getCityOptions(cities);

  const sourceCityItems = filter(
    cityItems,
    (item) => item.value !== destinationCity
  );
  const destinationCityItems = filter(
    cityItems,
    (item) => item.value !== sourceCity
  );

  /* TODO: Replace CityInputSelect when there is a new Currency Select */
  return (
    <Box paddingTop={3} paddingBottom={2} paddingX={{ desktop: 3 }}>
      <Tiles columns={{ mobile: 1, desktop: 3 }}>
        <Box marginBottom={1}>
          <Type size="1">
            Current city
            <Tooltip content="If you can't find a city, you can type the state name to see all cities available in that state." />
          </Type>
          <Box marginTop={1} />
          <CityInputSelect
            cityValue={sourceCity}
            cityItems={sourceCityItems}
            formName="source-city"
            fieldName="currentcity_change"
            cityType="currently_live"
            onChangeCity="inputs.sourceCity"
            onChange={onChange}
          />
        </Box>
        <Box marginBottom={1}>
          <Type size="1">New city</Type>
          <Box marginTop={1} />
          <CityInputSelect
            clearable
            autoFocus
            cityValue={destinationCity}
            cityItems={destinationCityItems}
            formName="destination-city"
            fieldName="city2compare_change"
            cityType="want_to_live"
            onChangeCity="inputs.destinationCity"
            onChange={onChange}
          />
        </Box>
        <Box>
          <HouseholdIncomeInput label="Pre-tax household income" />
        </Box>
      </Tiles>
    </Box>
  );
};

ColResultsHeader.displayName = 'ColResultsHeader';

export default ColResultsHeader;
